import { useGetPatientQueueByStaffQuery } from '@/core/services/patient-queue'
import { useMemo } from 'react'

export function useQueuedPatientsLoader() {
  const { data: patientQueue } = useGetPatientQueueByStaffQuery()

  return useMemo(() => {
    const queue = patientQueue?.queue ?? []
    const sortedQueue = [...queue].sort((a, b) => {
      const aVal = a.position ?? 0
      const bVal = b.position ?? 0
      return aVal - bVal
    })
    return sortedQueue
  }, [patientQueue])
}
